import { Div, Button } from '@codesuma/baseline'
import settings from '../../services/settings'
import { ISlider } from '../slider'
import style from './index.module.css'

// A shaft with a solid head — a long arrow, nothing like the single back
// chevron these pages keep in the corner. It is drawn pointing right; the left
// one is the same mark mirrored in CSS.
//
// One filled path, not a stroked shaft plus a head. The two would overlap where
// the shaft runs under the head, and the button paints at less than full
// opacity, so that overlap would read as a darker bar through the mark. As two
// subpaths of one path they are a single fill: they wind the same way, so the
// default nonzero rule fills the shared part once, and the shaft deliberately
// runs a unit past the head's back edge so no hairline seam is left between
// them. The shaft is the old stroke drawn out as a shape — 2 wide about y=12,
// with the round cap at its tail kept as an arc.
const ARROW_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true">'
    + '<path fill="currentColor" d="'
    + 'M16 11H3A1 1 0 0 0 3 13H16Z'
    + 'M21.7152 11.7966L16.265 7.90356C15.7355 7.52535 15 7.90385 15 8.55455V15.4454'
    + 'C15 16.0961 15.7355 16.4746 16.265 16.0964L21.7152 12.2034'
    + 'C21.8548 12.1037 21.8548 11.8963 21.7152 11.7966Z'
    + '"/>'
    + '</svg>'

// A step button on each side of a slider's title, on every page that swipes:
// the month, the day, the year and the block of years. The gesture was the only
// way through those pages and few people ever found it — and a mouse cannot
// find it at all.
//
// The arrows keep their physical sides and never change glyph: the left one
// always fetches what is on the left, which is the side the slider already
// brings it in from, so the buttons and the swipe agree. Which of the two is
// "next" flips with the calendar — Gregorian advances to the right, Jalaali to
// the left — so only the labels move. That is the same fact the pages feed to
// the slider's direction(), read here at the tap so the two cannot drift apart;
// sync() belongs next to that call, for a cached page re-entered after the
// calendar was switched underneath it.
//
// `unit` is what one tap moves, for the label: 'ماه', 'روز', 'سال'.
// The caller places it — see --arrows-top and --arrows-line in the stylesheet.
export const SliderArrows = (slider: ISlider, unit: string) => {
    const base = Div()
    base.addClass(style.base)

    const gregorian = () => settings.get().system === 'gregorian'

    const left = Button()
    left.addClass(style.btn)
    left.addClass(style.flip)
    left.html(ARROW_SVG)
    left.on('click', () => (gregorian() ? slider.prev() : slider.next()))
    base.append(left)

    const right = Button()
    right.addClass(style.btn)
    right.html(ARROW_SVG)
    right.on('click', () => (gregorian() ? slider.next() : slider.prev()))
    base.append(right)

    const sync = () => {
        left.attr('aria-label', gregorian() ? `${unit} قبل` : `${unit} بعد`)
        right.attr('aria-label', gregorian() ? `${unit} بعد` : `${unit} قبل`)
    }
    sync()

    return Object.assign(base, { sync })
}
